/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

// Import new patient detail components
import PatientDetailsBreadcrumb from "components/ClinicalManagement/Patients/PatientDetails/PatientDetailsBreadcrumb";
import PatientDetailsHeader from "components/ClinicalManagement/Patients/PatientDetails/PatientDetailsHeader";
import PatientDetailsSectionFilters from "components/ClinicalManagement/Patients/PatientDetails/PatientDetailsSectionFilters";
import TreatmentDetailsSection from "components/ClinicalManagement/Patients/PatientDetails/TreatmentDetailsSection";
import LaboratorySection from "components/ClinicalManagement/Patients/PatientDetails/LaboratorySection";
import NoteSection from "components/Common/NoteComponent/NoteSection";

import DiagnosticImagingSection from "components/ClinicalManagement/Patients/PatientDetails/DiagnosticImagingSection";
import MedicalRecordSection from "components/ClinicalManagement/Patients/PatientDetails/MedicalRecordSection";
import TeamChatSection from "components/ClinicalManagement/Patients/PatientDetails/TeamChatSection";
// import NursingSection from "components/ClinicalManagement/Patients/PatientDetails/NursingSection";
import MolecularMedicineSection from "components/ClinicalManagement/Patients/PatientDetails/MolecularMedicineSection";
import TreatmentTimelineSection from "components/ClinicalManagement/Patients/PatientDetails/TreatmentTimelineSection";
import AppointmentsSection from "components/ClinicalManagement/Patients/PatientDetails/AppointmentsSection";
import PrescriptionsSection from "components/ClinicalManagement/Patients/PatientDetails/PrescriptionsSection";
import AllergiesSection from "components/ClinicalManagement/Patients/PatientDetails/AllergiesSection";
import ImmunizationsSection from "components/ClinicalManagement/Patients/PatientDetails/ImmunizationsSection";
import ElectronicPrescriptionsSection from "components/ClinicalManagement/Patients/PatientDetails/ElectronicPrescriptionsSection";
import OrdersSection from "components/ClinicalManagement/Patients/PatientDetails/OrdersSection";
import MedicalConsentSection from "components/ClinicalManagement/Patients/PatientDetails/MedicalConsentSection";
import PatientVitals from "components/ClinicalManagement/Patients/PatientDetails/PatientVitals/PatientVitals";
import PatientAskConsentPopup from "components/ClinicalManagement/Patients/PatientAskConsentPopup";
import PatientViewConsentPopup from "components/ClinicalManagement/Patients/PatientViewConsentPopup";

import NursingSection from "./PatientDetails/NursingSection";

const PatientDetailsBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [hasMedicalConsent, setHasMedicalConsent] = useState(false);
  const [medicalConsentRequests, setMedicalConsentRequests] = useState([]);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [showViewConsentPopup, setShowViewConsentPopup] = useState(false);
  const [selectedConsentId, setSelectedConsentId] = useState(null);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Add state for section visibility
  const [selectedSections, setSelectedSections] = useState({
    treatmentDetails: true,
    laboratory: true,
    notes: true,
    diagnosticImaging: true,
    medicalRecord: true,
    teamChat: true,
    nursing: true,
    molecularMedicine: true,
    treatmentTimeline: true,
    appointments: true,
    prescriptions: true,
    allergies: true,
    immunizations: true,
    results: true,
    electronicPrescriptions: true,
    orders: true,
    medicalConsent: true,
    nursing: true,
    patientVitals: true,
  });

  const [patientObj, setPatientObj] = useState(null); // for passing as props with patient data
  const [doctorObj, setDoctorObj] = useState(null);
  const [clinicObj, setClinicObj] = useState(null);
  const [labTesterObj, setLabTesterObj] = useState(null);

  const [patientData, setPatientData] = useState({
    customId: "",
    insurance: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    dateOfBirth: "",
    profileImage: "",
    emergencyContact: "",
    bloodGroup: "",
    allergies: [],
    medicalHistory: "",
    address: "",
    whatsappNumber: "",
    company: "",
  });
  const [error, setError] = useState(null);

  const getPatientDetails = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      // console.log("requestUrl in user details", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details", response);

      if (response.status && response.data) {
        const data = response.data;

        const patientApiObj = {
          _id: data._id,
          company: data.company,
          name: data.name,
          surname: data.surname,
          email: data.email,
          position: data.position,
          address: data.address,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipcode,
          phone: data.phone,
          rank: data.rank,
          costperhour: data.costperhour,
          mincostperhour: data.mincostperhour,
          taglist: data.tags,
          image: data.userimage,
          fullname: data.userfullname,
          rolestring: data.userrole?.label,
          label: data.userfullname,
          value: data._id,
        };

        setPatientObj(patientApiObj);

        setPatientData({
          customId:
            data.customId ||
            data.patientId ||
            `ID ${data._id?.slice(-4) || "0000"}`,
          insurance:
            data.insurance ||
            data.insuranceProvider ||
            data.company ||
            "No Insurance",
          name: data.name || "",
          surname: data.surname || "",
          email: data.email || "",
          phone: data.phone || data.telephone || "",
          dateOfBirth: data.dateOfBirth || data.dob || "",
          profileImage: data.userimage || "",
          emergencyContact: data.emergencyContact || "",
          bloodGroup: data.bloodGroup || data.bloodType || "",
          allergies: data.allergies || [],
          medicalHistory: data.medicalHistory || data.about || "",
          address: data.address || "",
          whatsappNumber:
            data.whatsappNumber || data.whatsapp || data.phone || "",
          company: data.company || "",
        });
        setError(null);
      }
    } catch (error) {
      console.log(error.message);
      setError("Failed to load patient details");
    } finally {
      setIsLoading(false);
    }
  };

  const getDoctorOrLabtesterDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${userInfo._id}` +
        `?token=${token}`;

      console.log("requestUrl in Doctor or Labtester details", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details", response);

      if (response.status && response.data) {
        const data = response.data;

        const userApiObj = {
          _id: data._id,
          company: data.company,
          name: data.name,
          surname: data.surname,
          email: data.email,
          position: data.position,
          address: data.address,
          city: data.city,
          state: data.state,
          country: data.country,
          zipcode: data.zipcode,
          phone: data.phone,
          rank: data.rank,
          costperhour: data.costperhour,
          mincostperhour: data.mincostperhour,
          taglist: data.tags,
          image: data.userimage,
          fullname: data.userfullname,
          rolestring: data.userrole?.label,
          label: data.userfullname,
          value: data._id,
        };

        if (userInfo.role.slug === "DOCTOR") {
          setDoctorObj(userApiObj);
        } else if (userInfo.role.slug === "LAB_TECHNICIAN") {
          setLabTesterObj(userApiObj);
        }
      }
    } catch (error) {
      console.log(error.message);
    } finally {
    }
  };

  const getProviderClinicList = async () => {
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_LIST + `?token=${token}`;
      const response = await getData(requestUrl);

      console.log("response in getProviderClinics", response);

      if (response.status && response.data) {
        setClinicObj(response.data[0]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // check if current user has consent API_HAS_MEDICAL_CONSENT
  const checkMedicalConsent = async () => {
    setHasMedicalConsent(false);
    setMedicalConsentRequests([]);

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_HAS_MEDICAL_CONSENT +
        `/${params.id}` +
        `?token=${token}&details=1`;

      console.log("requestUrl in checkMedicalConsent", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in checkMedicalConsent", response);

      if (response.status && response.data) {
        // properly check if response.data is an array with items
        if (Array.isArray(response.data) && response.data.length > 0) {
          response.data.forEach((consent) => {
            if (consent.isapproved === true) {
              setHasMedicalConsent(true);
            }
          });
        }

        setMedicalConsentRequests(response.data || []);
      }
    } catch (error) {
      console.log("Error checking medical consent:", error);
      return false;
    }
  };

  // Handler to toggle section visibility
  const handleSectionToggle = (sectionId) => {
    setSelectedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  // Actions for AskConsentView
  const handleSelectElements = () => {
    // Minimal behavior: inform user how to select sections (you can open a modal here)
    setShowAlert(true);
    setAlertMessage(
      "Use the section filters to select which elements you need access to, then request patient approval."
    );
    setMessageType("info");
  };

  const handleRequestApproval = () => {
    // Minimal placeholder: simulate sending a consent request; replace with API call if available
    setShowAlert(true);
    setAlertMessage(
      "Consent request sent to the patient. You will be notified when they respond."
    );
    setMessageType("success");
  };

  const handleViewConsentClose = () => {
    setShowViewConsentPopup(false);
    setSelectedConsentId(null);
  };

  const handleAskConsentClose = () => {
    setShowConsentPopup(false);
    checkMedicalConsent(); // Refresh consent status after closing
  };

  useEffect(() => {
    if (params.id) {
      getPatientDetails();
      checkMedicalConsent();
    }
  }, [params.id]);

  useEffect(() => {
    if (
      userInfo?.role?.slug === "DOCTOR" ||
      userInfo?.role?.slug === "LAB_TECHNICIAN"
    ) {
      getDoctorOrLabtesterDetails();
    } else if (userInfo?.role?.slug === "CUSTOMER") {
      getProviderClinicList();
    }
  }, []);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_PATIENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Patient")}
          />
          <div className="container-fluid px-lg-5">
            <PatientDetailsBreadcrumb />
            <PatientDetailsHeader
              patientData={patientData}
              error={error}
              isLoading={isLoading}
            />

            {hasMedicalConsent ? (
              <PatientDetailsSectionFilters
                onSectionToggle={handleSectionToggle}
                selectedSections={selectedSections}
              />
            ) : null}

            {isLoading ? (
              <LoadingSkeleton />
            ) : hasMedicalConsent ? (
              <div className="row">
                {selectedSections.treatmentDetails && (
                  <div className="col-lg-6 mb-4">
                    <TreatmentDetailsSection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}
                {selectedSections.notes && (
                  <div className="col-lg-6 mb-4">
                    <NoteSection
                      noteAccessUserList={[userInfo._id]}
                      userId={params.id}
                    />
                  </div>
                )}
                {selectedSections.laboratory && (
                  <div className="col-lg-6 mb-4">
                    <LaboratorySection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      labTesterObj={labTesterObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}

                {selectedSections.diagnosticImaging && (
                  <div className="col-lg-6 mb-4">
                    <DiagnosticImagingSection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}
                {selectedSections.medicalRecord && (
                  <div className="col-lg-6 mb-4">
                    <MedicalRecordSection patientObj={patientObj} />
                  </div>
                )}

                {selectedSections.molecularMedicine && (
                  <div className="col-lg-6 mb-4">
                    <MolecularMedicineSection patientObj={patientObj} />
                  </div>
                )}
                {selectedSections.prescriptions && (
                  <div className="col-lg-6 mb-4">
                    <PrescriptionsSection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}
                {selectedSections.allergies && (
                  <div className="col-lg-6 mb-4">
                    <AllergiesSection patientObj={patientObj} />
                  </div>
                )}
                {selectedSections.immunizations && (
                  <div className="col-lg-6 mb-4">
                    <ImmunizationsSection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}
                {selectedSections.appointments && (
                  <div className="col-lg-6 mb-4">
                    <AppointmentsSection patientObj={patientObj} />
                  </div>
                )}
                {selectedSections.electronicPrescriptions && (
                  <div className="col-lg-6 mb-4">
                    <ElectronicPrescriptionsSection patientObj={patientObj} />
                  </div>
                )}
                {selectedSections.orders && (
                  <div className="col-lg-6 mb-4">
                    <OrdersSection />
                  </div>
                )}
                {selectedSections.medicalConsent && (
                  <div className="col-lg-6 mb-4">
                    <MedicalConsentSection />
                  </div>
                )}
                {selectedSections.nursing && (
                  <div className="col-lg-6 mb-4">
                    <NursingSection
                      patientObj={patientObj}
                      doctorObj={doctorObj}
                      clinicObj={clinicObj}
                    />
                  </div>
                )}
                {selectedSections.patientVitals && (
                  <div className="col-12">
                    <PatientVitals patientObj={patientObj} />
                  </div>
                )}
                {/* {selectedSections.teamChat && (
                  <div className="col-lg-6 mb-4">
                    <TeamChatSection />
                  </div>
                )}
                {selectedSections.treatmentTimeline && (
                  <div className="col-lg-6 mb-4">
                    <TreatmentTimelineSection />
                  </div>
                )} */}
              </div>
            ) : (
              /* No consent: show consent request and notes in two-column layout */
              <div className="row">
                <div className="col-lg-6 mb-4">
                  {/* If there are pending consent requests (sent but not approved), show waiting state */}
                  {medicalConsentRequests &&
                  medicalConsentRequests.length > 0 ? (
                    <div
                      className="p-4 rounded-8 border h-100"
                      role="status"
                      aria-live="polite"
                      style={{
                        backgroundColor: "#fffaf0",
                        borderColor: "#ffedd5",
                      }}
                    >
                      <div className="d-flex flex-column h-100">
                        <div className="mb-3">
                          <h4
                            className="mb-2"
                            style={{ color: "#b45309", fontWeight: 600 }}
                          >
                            <span
                              className="material-symbols-outlined me-2 align-middle"
                              aria-hidden
                            >
                              hourglass_top
                            </span>
                            Waiting for Patient Approval
                          </h4>
                          <p className="mb-3 text-muted">
                            A consent request has been sent to{" "}
                            {patientData.name ||
                              patientData.fullname ||
                              "the patient"}
                            . You will be notified when the patient approves or
                            denies the request.
                          </p>
                        </div>
                        <div
                          className="flex-grow-1"
                          style={{ maxHeight: "500px", overflowY: "auto" }}
                        >
                          <ul className="list-unstyled mb-0">
                            {medicalConsentRequests.map((req, idx) => (
                              <li
                                key={req._id || idx}
                                className="mb-3 p-3 border rounded"
                                style={{ backgroundColor: "#fff" }}
                              >
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div>
                                    <strong className="me-2">
                                      Request #{idx + 1}
                                    </strong>
                                    <small className="text-muted d-block mt-1">
                                      Access Type:{" "}
                                      {req.accesstype === "partial"
                                        ? "Partial"
                                        : "Full"}
                                    </small>
                                    <small className="text-muted d-block">
                                      Request Date:{" "}
                                      {req.createdAt
                                        ? new Date(
                                            req.createdAt
                                          ).toLocaleString()
                                        : "Date not available"}
                                    </small>
                                  </div>
                                  <span
                                    className={`badge ${
                                      req.isapproved
                                        ? "bg-success"
                                        : "bg-warning"
                                    }`}
                                  >
                                    {req.isapproved ? "Approved" : "Pending"}
                                  </span>
                                </div>
                                <div className="d-flex gap-2 mt-2">
                                  <button
                                    className={`btn btn-sm ${
                                      req.isapproved
                                        ? "btn-success"
                                        : "btn-outline-secondary"
                                    }`}
                                    disabled
                                  >
                                    {req.isapproved
                                      ? "Approved"
                                      : "Awaiting Approval"}
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#patientViewConsentOffCanvas"
                                    aria-controls="patientViewConsentOffCanvas"
                                    aria-label={`View request #${
                                      idx + 1
                                    } details`}
                                    onClick={() => {
                                      setSelectedConsentId(req._id);
                                      setShowViewConsentPopup(true);
                                    }}
                                  >
                                    View Details
                                  </button>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="p-4 rounded-8 h-100"
                      style={{ backgroundColor: "rgba(232, 131, 77, 0.08)" }}
                      role="region"
                      aria-label="Patient consent required"
                    >
                      <h4
                        className="mb-3"
                        style={{ color: "#E8834D", fontWeight: 600 }}
                      >
                        <span
                          className="material-symbols-outlined me-2 align-middle"
                          aria-hidden
                        >
                          warning
                        </span>
                        Patient Consent Required
                      </h4>
                      <p style={{ color: "#5a2f12", marginBottom: "0.75rem" }}>
                        To access the patient's full medical details you must
                        have explicit permission. Request consent from the
                        patient to view their medical records.
                      </p>
                      <p
                        style={{
                          color: "#5a2f12",
                          fontSize: "0.95rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        This helps protect patient privacy and ensures
                        compliance with data policies.
                      </p>

                      {/* Consent Process Steps */}
                      <div
                        className="mb-4 p-3 rounded"
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.7)" }}
                      >
                        <h6
                          className="fw-bold mb-3"
                          style={{ color: "#E8834D" }}
                        >
                          <span
                            className="material-symbols-outlined me-2 align-middle"
                            style={{ fontSize: "18px" }}
                          >
                            info
                          </span>
                          Consent Request Process
                        </h6>
                        <div className="d-flex flex-column gap-3">
                          <div className="d-flex gap-2">
                            <div style={{ minWidth: "24px" }}>
                              <span
                                className="badge rounded-circle"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#E8834D",
                                }}
                              >
                                1
                              </span>
                            </div>
                            <div>
                              <h6
                                className="mb-1 fw-semibold"
                                style={{ fontSize: "0.9rem", color: "#5a2f12" }}
                              >
                                Choose Consent Type
                              </h6>
                              <p className="mb-0 small text-muted">
                                <strong>Total Consent:</strong> Authorization of
                                all medical records till date
                                <br />
                                <strong>Partial Consent:</strong> Authorization
                                of selected medical records till date
                              </p>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <div style={{ minWidth: "24px" }}>
                              <span
                                className="badge rounded-circle"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#E8834D",
                                }}
                              >
                                2
                              </span>
                            </div>
                            <div>
                              <h6
                                className="mb-1 fw-semibold"
                                style={{ fontSize: "0.9rem", color: "#5a2f12" }}
                              >
                                Patient Approval
                              </h6>
                              <p className="mb-0 small text-muted">
                                Once approved, you will be able to view patient
                                details and available medical records as per the
                                consent granted.
                              </p>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <div style={{ minWidth: "24px" }}>
                              <span
                                className="badge rounded-circle"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#E8834D",
                                }}
                              >
                                3
                              </span>
                            </div>
                            <div>
                              <h6
                                className="mb-1 fw-semibold"
                                style={{ fontSize: "0.9rem", color: "#5a2f12" }}
                              >
                                Future Access Requests
                              </h6>
                              <p className="mb-0 small text-muted">
                                In the future, you can request additional
                                privileges on visible records through NIT Code
                                request for enhanced access.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#patientAskConsentOffCanvas"
                        aria-controls="patientAskConsentOffCanvas"
                        aria-label="Request patient approval"
                        onClick={() => setShowConsentPopup(true)}
                      >
                        Request Patient Approval
                      </button>
                    </div>
                  )}
                </div>

                {/* Notes section - always available in second column */}
                {selectedSections.notes && (
                  <div className="col-lg-6 mb-4">
                    <NoteSection
                      noteAccessUserList={[userInfo._id]}
                      userId={params.id}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}

          <PatientAskConsentPopup
            patientObj={patientObj}
            isOpen={showConsentPopup}
            onClose={handleAskConsentClose}
          />

          {/* Always render the offcanvas so Bootstrap can target it on first click */}
          <PatientViewConsentPopup
            isOpen={showViewConsentPopup}
            onClose={() => handleViewConsentClose}
            selectedConsentId={selectedConsentId}
          />
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default PatientDetailsBody;
